import { useState, useEffect } from 'react';

import { scrollToPageTop } from '@/utils/scroll';

export const useScrollToPos = (initialScrollPos: boolean| number | undefined = undefined) => {
  const [scrollToPos, setScrollToPos] = useState(initialScrollPos);
  let top = 0;

  useEffect(() => {
    if (scrollToPos || scrollToPos === 0) {
      top = 0;
      if (typeof scrollToPos === 'number') {
        top = scrollToPos;
      }
      setScrollToPos(false);
      scrollToPageTop(top);
    }
  }, [scrollToPos, setScrollToPos]);

  return setScrollToPos;
};
